export { POLICY_PAGES_EN } from '../../seed/policy-en.mjs';
